module.exports = __webpack_public_path__ + "img/icon-only.f3da781a.png";